import { createSelector } from 'reselect';

const selectEmailsState = () => (state) => state.get('emails');

const selectorsGetEmails = () =>
    createSelector(selectEmailsState(), (substate) => substate.get('dataGetEmails'));

const selectorsDeleteEmails = () =>
    createSelector(selectEmailsState(), (substate) => substate.get('dataDeleteEmails'));

const selectorsPutEmails = () =>
    createSelector(selectEmailsState(), (substate) => substate.get('dataPutEmails'));

const selectorsPostEmails = () =>
    createSelector(selectEmailsState(), (substate) => substate.get('dataPostEmails'));

export { selectorsGetEmails, selectorsDeleteEmails, selectorsPutEmails, selectorsPostEmails };
